import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Docs extends Component {
  render() {

    return (
      <div className="container content">
        <h4>Docs</h4>
         <br />
         <div className="card-panel">
           <h5>Installation</h5>
           <br />
           <Link to="/downloads/ModinetBeta.img">Modinet Beta OS</Link>
         </div>
      </div>
    )
  }
}



export default Docs;



// WEBPACK FOOTER //
// ./src/components/docs/AgentDocs.js